import { useContentGenerationWatcher } from 'hooks/calendar/useContentGenerationWatcher'
import { useV2GenerationChime } from 'hooks/calendar/useV2GenerationChime'

//mounts the watcher hook that polls for active generations
export const ContentGenerationWatcher = () => {
  useContentGenerationWatcher()
  useV2GenerationChime()
  return null
}
